import React from 'react';
import './App.css';
import Privacy from "./privacidad"
import ReportDetail from "./reportdetail"
import { BrowserRouter as Router, Route } from "react-router-dom";

function welcome() {
  return <h1>Welcome</h1>;
}

function App() {
  return (
    <Router>
        <div className={"site-content"}>
        <Route path="/" exact component={welcome} />
        <Route path="/privacidad/" component={Privacy} />
        <Route path="/report/:reportKey" component={ReportDetail} />
      </div>
    </Router>
  );
}

export default App;
